export default __webpack_public_path__ + "static/8_35-1--faa76637065472eb5b4f598e38bd5471.png";